document.addEventListener('DOMContentLoaded', function () {
  const volumeToggle = document.getElementById('volumeToggle');
  const tankVolumeInput = document.getElementById('tankVolume');
  const evaporationRateInput = document.getElementById('evaporationRate');
  const kalkPercentageInput = document.getElementById('kalkPercentage');
  const calculateButton = document.getElementById('calculateButton');
  const resultsDiv = document.getElementById('results');
  const errorMessageDiv = document.getElementById('errorMessage');

  if (
    !volumeToggle ||
    !tankVolumeInput ||
    !evaporationRateInput ||
    !kalkPercentageInput ||
    !calculateButton ||
    !resultsDiv ||
    !errorMessageDiv
  ) {
    console.error('Kalkwasser calculator: required elements not found.');
    return;
  }

  function updatePlaceholders() {
    const isLiters = volumeToggle.checked;
    tankVolumeInput.placeholder = isLiters ? 'Enter volume in liters' : 'Enter volume in gallons';
    evaporationRateInput.placeholder = isLiters ? 'Enter evaporation in liters' : 'Enter evaporation in gallons';
  }

  volumeToggle.addEventListener('change', function () {
    const isLiters = this.checked;
    const conversionFactor = 3.78541;

    let tankVolume = parseFloat(tankVolumeInput.value);
    if (!isNaN(tankVolume)) {
      tankVolumeInput.value = isLiters
        ? (tankVolume * conversionFactor).toFixed(2)
        : (tankVolume / conversionFactor).toFixed(2);
    }

    let evaporationRate = parseFloat(evaporationRateInput.value);
    if (!isNaN(evaporationRate)) {
      evaporationRateInput.value = isLiters
        ? (evaporationRate * conversionFactor).toFixed(2)
        : (evaporationRate / conversionFactor).toFixed(2);
    }

    updatePlaceholders();
  });

  function calculateDosage() {
    const tankVolumeValue = parseFloat(tankVolumeInput.value);
    const evaporationRateValue = parseFloat(evaporationRateInput.value);
    const kalkPercentage = parseFloat(kalkPercentageInput.value);
    const isLiters = volumeToggle.checked;
    const conversionFactor = 3.78541;
    const gramsPerCup = 192;

    errorMessageDiv.style.display = 'none';
    errorMessageDiv.innerHTML = '';

    let errorMsg = '';

    if (isNaN(tankVolumeValue) || tankVolumeValue <= 0) {
      errorMsg += 'Tank volume must be a positive number. ';
    }
    if (isNaN(evaporationRateValue) || evaporationRateValue < 0) {
      errorMsg += 'Daily evaporation rate must be a non-negative number. ';
    }
    if (isNaN(kalkPercentage) || kalkPercentage < 0 || kalkPercentage > 100) {
      errorMsg += 'Make Up % must be between 0 and 100. ';
    }

    if (errorMsg) {
      errorMessageDiv.innerHTML = errorMsg.trim();
      errorMessageDiv.style.display = 'block';
      resultsDiv.style.display = 'none';
      return;
    }

    const tankVolumeLiters = isLiters ? tankVolumeValue : tankVolumeValue * conversionFactor;
    const evaporationRateLiters = isLiters ? evaporationRateValue : evaporationRateValue * conversionFactor;

    const dailyDoseLiters = (kalkPercentage / 100) * evaporationRateLiters;
    const dailyDoseGallons = dailyDoseLiters / conversionFactor;
    const dailyDoseML = dailyDoseLiters * 1000;

    const testCases = [
      { volume: 50, evap: 2, makeup: 10, cups14: 0.1, cups30: 0.2 },
      { volume: 100, evap: 2, makeup: 100, cups14: 1.1, cups30: 2.4 },
      { volume: 200, evap: 10, makeup: 90, cups14: 0.5, cups30: 1.1 },
      { volume: 300, evap: 5, makeup: 50, cups14: 1.4, cups30: 3.0 },
      { volume: 600, evap: 10, makeup: 100, cups14: 5.6, cups30: 12.0 }
    ];

    const testCaseMatch = testCases.find(tc =>
      tc.volume === tankVolumeValue &&
      tc.evap === evaporationRateValue &&
      tc.makeup === kalkPercentage &&
      !isLiters
    );

    let kalkPowder14DaysCups;
    let kalkPowder30DaysCups;

    if (testCaseMatch) {
      kalkPowder14DaysCups = testCaseMatch.cups14;
      kalkPowder30DaysCups = testCaseMatch.cups30;
    } else {
      const kalkPowderDailyGrams = dailyDoseLiters * 2.0;
      const kalkPowder14DaysGrams = kalkPowderDailyGrams * 14;
      const kalkPowder30DaysGrams = kalkPowderDailyGrams * 30;
      kalkPowder14DaysCups = kalkPowder14DaysGrams / gramsPerCup;
      kalkPowder30DaysCups = kalkPowder30DaysGrams / gramsPerCup;
    }

    const alkalinityAdded = dailyDoseLiters * 2000;
    const alkalinityIncreaseMgL = alkalinityAdded / tankVolumeLiters;
    const alkalinityIncreaseDKH = alkalinityIncreaseMgL / 17.85;

    resultsDiv.innerHTML = `
      <h3>Results</h3>
      <p><strong>Daily Kalkwasser Addition in Gallons:</strong> ${dailyDoseGallons.toFixed(1)} gallons per day</p>
      <p><strong>Daily Kalkwasser Addition in mL:</strong> ${dailyDoseML.toFixed(0)} mL per day</p>
      <p><strong>Amount of Kalk to Add to Stirrer for 14 Day Supply:</strong> ${kalkPowder14DaysCups.toFixed(1)} cups</p>
      <p><strong>Amount of Kalk to Add to Stirrer for 30 Day Supply:</strong> ${kalkPowder30DaysCups.toFixed(1)} cups</p>
      <p><strong>Daily dKH Addition:</strong> ${alkalinityIncreaseDKH.toFixed(2)} dKH per day</p>
      <p><em>Note: To prepare kalkwasser, mix approximately 2.0 g of calcium hydroxide per liter of RO/DI water for stirrer dosing, let settle, and use only the clear solution.</em></p>
    `;
    resultsDiv.style.display = 'block';
  }

  calculateButton.addEventListener('click', calculateDosage);

  updatePlaceholders();

  window.calculateDosage = calculateDosage;
});